import { Autocomplete, TextField } from '@mui/material';
import { FC, memo } from 'react';
import { ShipperEntity } from 'src/entities/shipperEntity';

interface ShipperAutocompleteProps {
  label: string;
  id: string;
  shipperData: ShipperEntity[];
  selectedShipperId: number | null;
  selectedShipperName: string | null;
  onShipperIdChange: (shipperId: number | null) => void;
  onShipperNameChange: (shipperName: string | null) => void;
  loading?: boolean;
}

const ShipperAutocomplete: FC<ShipperAutocompleteProps> = memo(({
  label,
  id,
  shipperData,
  selectedShipperId,
  selectedShipperName,
  onShipperIdChange,
  onShipperNameChange,
  loading = false
}) => (
  <Autocomplete
    freeSolo
    options={shipperData.map((d) => ({
      ...d,
      label: d.name
    }))}
    loading={loading}
    value={selectedShipperName || ''}
    onChange={(_, value) => {
      if (typeof value === 'object' && value !== null) {
        // 選択肢から選択された場合
        onShipperIdChange(value.id);
        onShipperNameChange(value.name);
      } else if (typeof value === 'string') {
        // 文字列入力の場合
        const shipper = shipperData.find((it) => it.name === value);
        if (shipper) {
          // 既存の選択肢と一致する場合
          onShipperIdChange(shipper.id);
          onShipperNameChange(shipper.name);
        } else {
          // 新しい値の場合
          onShipperIdChange(null);
          onShipperNameChange(value);
        }
      } else {
        // null/undefinedの場合
        onShipperIdChange(null);
        onShipperNameChange(null);
      }
    }}
    onInputChange={(_, value) => {
      // 直接入力時の値を取得
      const shipper = shipperData.find((it) => it.name === value);
      if (shipper) {
        onShipperIdChange(shipper.id);
        onShipperNameChange(shipper.name);
      } else {
        onShipperIdChange(null);
        onShipperNameChange(value || null);
      }
    }}
    multiple={false}
    fullWidth
    renderInput={(params) => (
      <TextField
        {...params}
        margin="dense"
        type="text"
        fullWidth
        label={label}
        id={id}
        InputLabelProps={{ shrink: true }}
      />
    )}
  />
));

export default ShipperAutocomplete;
